import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from "../../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var bootstrap: any;

@Component({
  selector: 'app-tres-rios',
  templateUrl: './tres-rios.component.html',
  standalone: false,

})

export class TresRiosComponent implements OnInit, AfterViewInit {

  // ---CMS---
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  tresRios_content: string = 'linhas-tres-rio';
  cartoes_tresRios_content: string = 'linhas-lista-cartoes-tres-rios';
  tresRiosInfo: any = {};
  cardsInfoShow: any[] = [];

  constructor(
    private cmsService: CmsService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private title: Title
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['tresrios']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit(){
    this.getContent();
    this.getContentCards();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (fragment) {

          const tabTriggerEl = document.querySelector(`a.nav-link[href="#${fragment}"]`) as HTMLElement | null;

          if (tabTriggerEl) {
            const tab = new bootstrap.Tab(tabTriggerEl);
            tab.show();
          }
        }
      });
    }, 500);
  }

  getContent(){
    this.cmsService.getContentList(this.tresRios_content, this.language).subscribe(
      {
        next: data => {
          this.tresRiosInfo = data['body']['data'];
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getContentCards(){
    this.cmsService.getContentList(this.cartoes_tresRios_content, this.language).subscribe(
      {
        next: data => {
          this.cardsInfoShow =  data['body']['data'];

          this.cardsInfoShow.sort((a,b) => (a.Ordem > b.Ordem) ? 1 : -1 );
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }
}
